import { render, staticRenderFns } from "./ReportPageV2Wrapper.vue?vue&type=template&id=71b88641&scoped=true"
import script from "./ReportPageV2Wrapper.vue?vue&type=script&lang=js"
export * from "./ReportPageV2Wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b88641",
  null
  
)

export default component.exports